{
    "list": {
      "title": "Filtry",
      "create": "Vytvořit filtr",
      "import": "Importovat filtr",
      "loadError": "Při načítání filtrů došlo k chybě.",
      "statusAll": "Vše",
      "statusEnabled": "Zapnuto",
      "statusDisabled": "Vypnuto",
      "noStatusFilters": "Žádné {{status}} filtry",
      "noFilters": "Žádné filtry tu nejsou..",
      "addNew": "Přidat nový",
      "copied": "Filtr zkopírován do schránky!",
      "copyFailed": "Nepodařilo se zkopírovat JSON do schránky.",
      "fetchFailed": "Nepodařilo se získat data filtru.",
      "deleted": "Filtr {{name}} byl odstraněn",
      "duplicated": "Filtr {{name}} byl duplikován",
      "updated": "{{name}} byl úspěšně aktualizován",
      "removeTitle": "Odstranit filtr: {{name}}",
      "removeText": "Jste si jisti, že chcete odstranit tento filtr? Tato akce je nevratná.",
      "edit": "Upravit",
      "exportJson": "Exportovat JSON",
      "exportJsonDiscord": "Exportovat JSON do Discordu",
      "toggle": "Přepnout",
      "duplicate": "Duplikovat",
      "delete": "Odstranit",
      "toggleSuccess": "{{name}} byl úspěšně {{state}}",
      "enabledState": "zapnuto",
      "disabledState": "vypnuto",
      "autoUpdatedTitle": "Tento filtr je automaticky aktualizován listem",
      "priority": "Priorita",
      "actions": "Akce",
      "noActionsDefined": "Žádné akce definovány. Nastavte akce pro povolení stahování.",
      "noActionsEnabled": "Musíte povolit alespoň jednu akci v filtru, jinak se nic nestáhne.",
      "downloads": "Stažení",
      "per": "za",
      "usesDisabledIndexers": "Používá vypnuté indexery: {{names}}",
      "noIndexer": "ŽÁDNÝ INDEXER",
      "sort": {
        "label": "Seřadit",
        "default": "Nejnovější",
        "nameAsc": "Název A-Z",
        "nameDesc": "Název Z-A",
        "priorityDesc": "Priorita Vysoká-Nízká",
        "priorityAsc": "Priorita Nízká-Vysoká",
        "createdDesc": "Nejnověji vytvořené nejprve",
        "createdAsc": "Nejnověji vytvořené jako poslední",
        "updatedDesc": "Nejnověji aktualizované nejprve",
        "updatedAsc": "Nejnověji aktualizované jako poslední"
      },
      "indexerFilter": {
        "label": "Indexer",
        "all": "Všechny indexery"
      }
    },
    "details": {
      "tabs": {
        "general": "Obecné",
        "moviesTv": "Filmy a TV",
        "music": "Hudba",
        "advanced": "Pokročilé",
        "external": "Externí",
        "actions": "Akce",
        "notifications": "Notifikace",
        "new": "NOVÝ"
      },
      "removeTitle": "Odstranit filtr: {{name}}",
      "removeText": "Jste si jisti, že chcete odstranit tento filtr? Tato akce je nevratná.",
      "delete": "Odstranit filtr",
      "reset": "Resetovat hodnoty formuláře",
      "resetSuccess": "Všechny hodnoty filtru byly resetovány.",
      "save": "Uložit",
      "validationError": "Validace selhaly",
      "validationErrors": "Validace selhaly",
      "mustSelectClient": "Musíte vybrat klienta"
    },
    "importer": {
      "title": "Importovat filtr (v JSON nebo autodl-irssi formátu)",
      "import": "Importovat",
      "cancel": "Zrušit",
      "jsonImported": "Filtr '{{name}}' byl úspěšně importován!",
      "jsonImportFailed": "Nepodařilo se importovat JSON data. Informace jsou zaznamenány do logů.",
      "invalidFormat": "Nelze importovat daný filtr -- není v JSON nebo autodl-irssi formátu.",
      "autodlImportFailed": "Nepodařilo se importovat autodl-irssi filtr '{{name}}'. Informace jsou zaznamenány do logů.",
      "autodlImportedOne": "Filtr '{{name}}' byl úspěšně importován!",
      "autodlImportedMany": "Všechny {{count}} filtry byly úspěšně importovány!",
      "autodlImportedPartial": "{{success}}/{{total}} filtry byly úspěšně importovány. Informace jsou zaznamenány do logů.",
      "placeholder": "Vložte sem svá data filtru (buď autobrr JSON formát nebo celá autodl-irssi konfigurace)",
      "warnings": "Varování při importu"
    },
    "general": {
      "filterName": "Název filtru",
      "filterNamePlaceholder": "např. Filtr 1",
      "announceTypes": "Typy oznámení",
      "announceTypesTooltip": "NOVÉ! Shoda s releasy, která obsahují některý z vybraných typů oznámení.",
      "indexers": "Indexery",
      "rulesTitle": "Pravidla",
      "rulesSubtitle": "Určete pravidla, jak by měly být zpracovávány/vybrány torrenty.",
      "minSize": "Minimální velikost",
      "maxSize": "Maximální velikost",
      "sizePlaceholder": "např. 100MiB, 80GB",
      "sizeTooltip": "Podporuje jednotky jako MB, MiB, GB, atd.",
      "delay": "Zpoždění",
      "delayPlaceholder": "Počet sekund, po kterém se mají provést akce",
      "delayTooltip": "Počet sekund čekání, po kterém se mají provést akce.",
      "priority": "Priorita",
      "priorityPlaceholder": "Vysoké číslo = vysoká priorita",
      "priorityTooltip": "Filtry jsou kontrolovány v pořadí priorit. Vysoké číslo = vysoká priorita.",
      "maxDownloads": "Maximální počet stahování",
      "maxDownloadsPlaceholder": "Akceptuje jakékoli číslo (0 je neomezeno)",
      "maxDownloadsTooltip": "Počet maximálních stahování specifikovaný jednotlivými jednotkami času.",
      "maxDownloadsPer": "Maximální počet stahování za",
      "selectUnit": "Vybrat jednotku",
      "maxDownloadsPerTooltip": "Jednotka času pro počítání maximálního počtu stahování na filtr.",
      "skipDuplicatesProfile": "Přeskočit profil duplicit",
      "selectProfile": "Vybrat profil",
      "skipDuplicatesProfileTooltip": "Vyberte profil pro přeskočení duplicit.",
      "enabled": "Zapnuto",
      "enabledDescription": "Povolit nebo zakázat tento filtr."
    },
    "actionsSection": {
      "title": "Akce",
      "subtitle": "Přidat do stahovacích klientů nebo spustit vlastní příkazy.",
      "addNew": "Přidat nový",
      "empty": "Dosud žádné akce!",
      "deleted": "Akce {{name}} byla odstraněna",
      "removeTitle": "Odstranit akci filtru",
      "removeText": "Jste si jisti, že chcete odstranit tuto akci? Toto rozhodnutí je nevratné.",
      "actionTitle": "Akce",
      "actionSubtitle": "Definujte stahovacího klienta pro vaši akci a jeho název",
      "actionType": "Typ akce",
      "selectType": "Vybrat typ",
      "actionTypeTooltip": "Vyberte typ akce.",
      "name": "Název",
      "removeAction": "Odstranit akci",
      "close": "Zavřít"
    },
    "notificationsSection": {
      "title": "Notifikace filtru",
      "subtitle": "Konfigurujte, které notifikace by měly být odeslány pro tento filtr. Tyto nastavení přepíší globální nastavení notifikací.",
      "addNotification": "Přidat notifikaci",
      "empty": "Dosud nemáte žádné notifikace filtru!",
      "selectNotification": "Vybrat notifikaci",
      "muted": "Ztlumeno",
      "eventsCount_one": "{{count}} událost",
      "eventsCount_other": "{{count}} události",
      "removeTitle": "Odstranit notifikaci",
      "removeText": "Jste si jisti, že chcete odstranit tuto notifikaci? Tato akce je nevratná.",
      "notificationTitle": "Notifikace",
      "notificationSubtitle": "Vyberte službu notifikace a události k aktivaci",
      "notificationService": "Služba notifikace",
      "selectNotificationService": "Vybrat notifikaci",
      "notificationServiceTooltip": "Vyberte službu notifikace, která se má použít pro tento filtr.",
      "notificationSettings": "Nastavení notifikací",
      "muteFilter": "Ztlumit filtr",
      "muteFilterDesc": "Zakázat všechny notifikace pro tento filtr. Když je filtr ztlumen, nebudou odeslány žádné notifikace pro releasy, které odpovídají tomuto filtru.",
      "mutedInfo": "Filtr ztlumen - přepíše všechna globální nastavení notifikací",
      "triggerEvents": "Aktivovat události",
      "pushApproved": "Úspěšný push",
      "pushRejected": "Odmítnutý push",
      "pushError": "Chybný push",
      "pushApprovedDesc": "Odeslat notifikaci, když je release úspěšně odeslán do klienta",
      "pushRejectedDesc": "Odeslat notifikaci, když je release odmítnut",
      "pushErrorDesc": "Odeslat notifikaci, když dojde k chybě při zpracování",
      "removeNotification": "Odstranit notifikaci",
      "close": "Zavřít"
    },
    "advanced": {
      "common": {
        "useRegex": "Použít Regex",
        "regexTooltip1": "Toto pole má plnou podporu regex (varianta Golang).",
        "regexTooltip2": "Pamatujte, že musíte zaškrtnout Použít Regex, pokud používáte více než * a ?.",
        "regexTooltip3": "Režim: (?i) ignoruje velikost písmen"
      },
      "releases": {
        "title": "Názvy",
        "subtitle": "Podmínka shody releasu a/nebo ignorování jiných názvů releasu.",
        "match": "Podmínka shody releasu",
        "matchPlaceholder": "eg. *some?movie*,*some?show*s01*",
        "except": "Ignorovat release",
        "exceptPlaceholder": "eg. *bad?movie*,*bad?show*s03*",
        "alert": "Zeptejte se sami sebe:",
        "matchWarning": "Máte dobrý důvod použít 'Podmínka shody releasu' místo jedné z ostatních karet?",
        "exceptWarning": "Máte dobrý důvod použít 'Ignorovat release' místo jedné z ostatních karet?"
      },
      "groups": {
        "title": "Skupiny",
        "subtitle": "Podmínka shody skupin a/nebo ignorování jiných skupin.",
        "match": "Podmínka shody skupin",
        "matchPlaceholder": "např. group1,group2",
        "matchTooltip": "Seznam skupin, které mají být shodovány (oddělené čárkami).",
        "except": "Ignorovat skupiny",
        "exceptPlaceholder": "např. badgroup1,badgroup2",
        "exceptTooltip": "Seznam skupin, které mají být ignorovány (přednost před Podmínka shody skupin)."
      },
      "categories": {
        "title": "Kategorie",
        "subtitle": "Podmínka shody kategorií a/nebo ignorování jiných kategorií.",
        "match": "Podmínka shody kategorií",
        "matchPlaceholder": "např. *category*,category1",
        "matchTooltip": "Seznam kategorií, které mají být shodovány (oddělené čárkami).",
        "except": "Ignorovat kategorie",
        "exceptPlaceholder": "např. *category*",
        "exceptTooltip": "Seznam kategorií, které mají být ignorovány (přednost před Podmínka shody kategorií)."
      },
      "tags": {
        "title": "Tagy",
        "subtitle": "Podmínka shody tagů a/nebo ignorování jiných tagů.",
        "match": "Podmínka shody tagů",
        "matchPlaceholder": "např. tag1,tag2",
        "matchTooltip": "Seznam tagů, které mají být shodovány (oddělené čárkami).",
        "matchLogic": "Logika shodování",
        "matchLogicDefault": "libovolná",
        "matchLogicTooltip": "Logika použitá k shodování filtru tagů.",
        "except": "Ignorovat tagy",
        "exceptPlaceholder": "např. tag1,tag2",
        "exceptTooltip": "Seznam tagů, které mají být ignorovány (přednost před Podmínka shody tagů).",
        "exceptLogic": "Logika ignorování",
        "exceptLogicDefault": "libovolná",
        "exceptLogicTooltip": "Logika použitá k ignorování filtru tagů."
      },
      "uploaders": {
        "title": "Uploadeři",
        "subtitle": "Podmínka shody uploaderů a/nebo ignorování jiných uploaderů.",
        "match": "Podmínka shody uploaderů",
        "matchPlaceholder": "např. uploader1,uploader2",
        "matchTooltip": "Seznam uploaderů, které mají být shodovány (oddělené čárkami).",
        "except": "Ignorovat uploadery",
        "exceptPlaceholder": "např. anonymous1,anonymous2",
        "exceptTooltip": "Seznam uploaderů, které budou ignorováni (přednost před Podmínka shody uploaderů)."
      },
      "language": {
        "title": "Jazyk",
        "subtitle": "Podmínka shody jazyků a/nebo ignorování jiných jazyků.",
        "match": "Podmínka shody jazyků",
        "except": "Ignorovat jazyky"
      },
      "origins": {
        "title": "Původ",
        "subtitle": "Podmínka shody původů a/nebo ignorování jiných původů.",
        "match": "Podmínka shody původů",
        "except": "Ignorovat původy"
      },
      "freeleech": {
        "title": "Freeleech",
        "subtitle": "Podmínka shody freeleech a/nebo ignorování freeleech.",
        "percent": "Procento freeleech",
        "percentPlaceholder": "např. 50,75-100",
        "percentTooltip1": "Freeleech může být oznámen jako binární ano/ne hodnota nebo jako procento, v závislosti na indexeru. Použijte jednu nebo druhou variantu.",
        "percentTooltip2": "Přepínač Freeleech přepíše toto pole, pokud je zapnutý.",
        "percentTooltip3": "Podrobnosti naleznete v naší dokumentaci:",
        "toggle": "Freeleech",
        "toggleDescription": "Nelze použít s Procentem freeleech. Přepíše Procento freeleech, pokud je zapnutý.",
        "toggleTooltip1": "Freeleech může být oznámen jako binární ano/ne hodnota nebo jako procento, v závislosti na indexeru. Použijte jednu nebo druhou variantu.",
        "toggleTooltip2": "Toto pole přepíše Procento freeleech, pokud je zapnutý.",
        "toggleTooltip3": "Podrobnosti naleznete v naší dokumentaci:"
      },
      "feedSpecific": {
        "title": "RSS/Torznab/Newznab-specifické",
        "subtitle": "Tyto možnosti jsou pouze pro kanály jako RSS, Torznab a Newznab",
        "matchDescription": "Podmínka shody popisu",
        "matchDescriptionPlaceholder": "např. *some?movie*,*some?show*s01*",
        "exceptDescription": "Ignorovat popis",
        "exceptDescriptionPlaceholder": "např. *bad?movie*,*bad?show*s03*",
        "minSeeders": "Minimální počet seedů",
        "maxSeeders": "Maximální počet seedů",
        "minLeechers": "Minimální počet leecherů",
        "maxLeechers": "Maximální počet leecherů",
        "countPlaceholder": "Akceptuje jakékoli číslo (0 je neomezeno)",
        "seedersTooltip": "Počet {{type}} jako specifikovaný jednotlivými jednotkami času. Pouze pro Torznab"
      },
      "rawReleaseTags": {
        "title": "Nezpracované tagy releasu",
        "subtitlePrefix": "Pouze pro pokročilé uživatele",
        "subtitleSuffix": "Toto je nezpracovaný releaseTags řetězec z oznámení.",
        "warning": "Tohle může být něco jiného, než co si myslíte. Pro velmi pokročilé uživatele, kteří vědí, jak se věci detekují.",
        "match": "Podmínka shody tagů releasu",
        "except": "Ignorovat tagy releasu",
        "placeholder": "např. *mkv*,*foreign*"
      }
    },
    "moviesTv": {
      "title": "Filmy / Seriály",
      "placeholder": "např. Movie,Show 1,Show?2",
      "wildcardTooltip": "Můžete použít základní filtraci jako hvězdičky * nebo nahradit jednotlivé znaky s ?",
      "years": "Roky",
      "yearsPlaceholder": "např. 2018,2019-2021",
      "yearsTooltip": "Toto pole přijímá rozsah let a/nebo čárkou oddělené jednotlivé roky.",
      "seasonEpisode": {
        "title": "Sezóny, Epizody a Datum",
        "subtitle": "Nastavte podmínky shody sezóny, epizody, roku, měsíců a dní.",
        "seasons": "Sezóny",
        "seasonsPlaceholder": "např. 1,3,2-6",
        "seasonsTooltip": "Podrobnosti naleznete v naší dokumentaci:",
        "episodes": "Epizody",
        "episodesPlaceholder": "např. 2,4,10-20",
        "episodesTooltip": "Podrobnosti naleznete v naší dokumentaci:",
        "dailyShows": "Denní pořady",
        "months": "Měsíce",
        "monthsPlaceholder": "např. 4,2-9",
        "monthsTooltip": "Toto pole přijímá rozsah měsíců a/nebo čárkou oddělené jednotlivé měsíce.",
        "days": "Dny",
        "daysPlaceholder": "např. 1,15-30",
        "daysTooltip": "Toto pole přijímá rozsah dnů a/nebo čárkou oddělené jednotlivé dny.",
        "smartEpisode": "Inteligentní epizoda",
        "smartEpisodeDescription": "Neshodujte epizody starší než poslední která byla shodována."
      },
      "quality": {
        "title": "Kvalita",
        "subtitle": "Nastavte rozlišení, zdroj, kodek a související podmínky shody.",
        "resolutions": "Rozlišení",
        "resolutionsTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných rozlišení.",
        "sources": "Zdroje",
        "sourcesTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných zdrojů.",
        "codecs": "Kodeky",
        "codecsTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných kodeků.",
        "containers": "Kontejnery",
        "containersTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných kontejnerů.",
        "matchHdr": "Shodovat HDR",
        "matchHdrTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných HDR označení.",
        "exceptHdr": "Ignorovat HDR",
        "exceptHdrTooltip": "Neshoduje releasy, které obsahují jakékoli z vybraných HDR označení (přednost před Shodovat HDR).",
        "matchOther": "Shodovat jiné",
        "matchOtherTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných označení.",
        "exceptOther": "Ignorovat jiné",
        "exceptOtherTooltip": "Neshoduje releasy, které obsahují jakékoli z vybraných jiných označení (přednost před Shodovat jiné)."
      }
    },
    "music": {
      "artists": "Umělci",
      "artistsPlaceholder": "např. Umělec 1",
      "albums": "Alba",
      "albumsPlaceholder": "např. To Album",
      "wildcardTooltip": "Můžete použít základní filtraci jako hvězdičky * nebo nahradit jednotlivé znaky s ?",
      "matchRecordLabels": "Shodovat značky hudebních společností",
      "matchRecordLabelsPlaceholder": "např. Anjunabeats, Armada",
      "matchRecordLabelsTooltip": "Seznam hudebních společností, které mají být shodovány (oddělené čárkami). Pouze Orpheus a Redacted toto podporují.",
      "exceptRecordLabels": "Ignorovat hudební společnosti",
      "exceptRecordLabelsPlaceholder": "např. Anjunadeep, Armind",
      "exceptRecordLabelsTooltip": "Seznam hudebních společností, které mají být ignorovány (přednost před Shodovat hudební společnosti). Pouze Orpheus a Redacted toto podporují.",
      "releaseDetails": {
        "title": "Detaily vydání",
        "subtitle": "Typ (Album, Single, EP, atd.) a rok vydání (pokud je oznámen)",
        "musicType": "Typ hudby",
        "musicTypeTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných typů.",
        "years": "Roky",
        "yearsPlaceholder": "např. 2018,2019-2021",
        "yearsTooltip": "Toto pole přijímá rozsah let a/nebo čárkou oddělené jednotlivé roky."
      },
      "quality": {
        "title": "Kvalita",
        "subtitle": "Formát, zdroj, log, atd.",
        "format": "Formát",
        "formatTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných formátů. Toto je přepsáno Perfektním FLACem.",
        "quality": "Kvalita",
        "qualityTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných kvalit. Toto je přepsáno Perfektním FLACem.",
        "media": "Média",
        "mediaTooltip": "Shoduje releasy, které obsahují jakékoli z vybraných zdrojů. Toto je přepsáno Perfektním FLACem.",
        "cue": "Cue",
        "cueDescription": "Musí obsahovat informace CUE",
        "log": "Log",
        "logDescription": "Musí obsahovat informace LOG",
        "logScore": "Logové skóre",
        "logScorePlaceholder": "např. 100",
        "logScoreTooltip": "Logové skóre má hodnotu od 0 do 100. Toto je přepsáno Perfektním FLACem.",
        "or": "NEBO",
        "perfectFlac": "Perfektní FLAC",
        "perfectFlacDescription": "Přepíše všechny možnosti o kvalitě, zdroji, formátu a cue/log/logové skóre.",
        "perfectFlacTooltip": "Přepíše všechny možnosti o kvalitě, zdroji, formátu a CUE/LOG/LOGové skóre.",
        "perfectFlacHint": "Toto je to, co chcete v 90% případů (místo možností výše)."
      }
    },
    "external": {
      "title": "Externí filtry",
      "subtitle": "Spusťte externí skripty nebo webhooky a zkontrolujte stav jako součást filtrace.",
      "addNew": "Přidat nový",
      "empty": "Dosud žádné externí filtry!",
      "removeTitle": "Odstranit externí filtr",
      "removeText": "Jste si jisti, že chcete odstranit tento externí filtr? Toto akce nemůže být vrácena.",
      "sectionTitle": "Externí filtr",
      "sectionSubtitle": "Definujte typ vašeho filtru a jeho název",
      "type": "Typ",
      "name": "Název",
      "onError": "Při chybě",
      "selectType": "Vybrat typ",
      "typeTooltip": "Vyberte typ tohoto externího filtru.",
      "onErrorTooltip": "Vyberte co dělat při chybě tohoto externího filtru.",
      "remove": "Odstranit externí",
      "close": "Zavřít",
      "types": {
        "EXEC": "Spustit",
        "WEBHOOK": "Webhook"
      },
      "onErrorOptions": {
        "REJECT": "Odmítnout",
        "CONTINUE": "Pokračovat na další"
      },
      "execute": {
        "title": "Spustit",
        "subtitle": "Specifikujte spustitelný soubor, argument a očekávaný exit kód který se spustí před filtrováním",
        "path": "Cesta ke spustitelnému souboru",
        "pathPlaceholder": "Absolutní cesta ke spustitelnému souboru např. /bin/test",
        "pathTooltip": "Pro vlastní příkazy byste měli specifikovat plnou cestu k binárnímu/programu, který chcete spustit. A můžete zahrnout vlastní statické proměnné:",
        "args": "Argumenty spustitelného souboru",
        "argsPlaceholder": "Argumenty např. --test \"{{ .TorrentName }}\"",
        "expectedExitStatus": "Očekávaný exit kód"
      },
      "request": {
        "title": "Požadavek",
        "subtitle": "Specifikujte vaši požadovanou destinaci, hlavičky a očekávaný zpětný stav",
        "endpoint": "Koncový bod",
        "endpointPlaceholder": "Host např. http://localhost/webhook",
        "endpointTooltip": "URL nebo IP vašeho API. Předejte parametry a nastavte API tokeny atd.",
        "httpMethod": "HTTP metoda",
        "httpMethodDefault": "Vybrat HTTP metodu",
        "httpMethodTooltip": "Vyberte HTTP metodu pro tento webhook. Ve výchozím nastavení je metoda POST",
        "headers": "HTTP požadavkové hlavičky",
        "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
        "expectedStatus": "Očekávaný HTTP stavový kód"
      },
      "retry": {
        "title": "Opakování",
        "subtitle": "Opakování při selhání požadavku",
        "retryStatus": "Opakování http stavových kódů",
        "retryStatusPlaceholder": "Opakování na stav např. 202, 204",
        "retryAttempts": "Maximum opakování",
        "retryDelaySeconds": "Zpožděné opakování v sekundách"
      },
      "payload": {
        "title": "Payload",
        "subtitle": "Specifikujte váš JSON payload",
        "data": "Data (json)",
        "dataPlaceholder": "Požadovaná data: { \"klíč\": \"hodnota\" }"
      }
    },
    "actionComponents": {
      "instance": {
        "title": "Instance",
        "subtitle": "Vyberte konkrétní instanci, která má tento filtr zpracovat."
      },
      "common": {
        "category": "Kategorie",
        "categoryPlaceholder": "např. kategorie",
        "categoryTooltip": "Kategorie musí již existovat.",
        "savePath": "Cesta k uložení",
        "savePathPlaceholder": "např. /full/path/to/download_folder",
        "numberNoLimit": "Akceptuje jakékoli číslo (0 je neomezeno)",
        "limitsTitle": "Limity",
        "limitsSubtitle": "Nastavte své limity rychlosti/share ratio/času seedování",
        "limitDownloadKib": "Omezit rychlost downloadu (KiB/s)",
        "limitUploadKib": "Omezit rychlost uploadu (KiB/s)",
        "limitDownloadKb": "Omezit rychlost downloadu (KB/s)",
        "limitUploadKb": "Omezit rychlost uploadu (KB/s)",
        "ratioLimit": "Omezit poměr sdílení",
        "seedTimeMinutes": "Omezit čas seedování (minuty)",
        "addPaused": "Přidat jako pozastavené",
        "addPausedDescription": "Přidat torrent jako pozastavený",
        "skipHashCheck": "Přeskočit hashování",
        "skipHashCheckDescription": "Přidat torrent a přeskočit hashování",
        "announceTitle": "Oznámení",
        "announceSubtitle": "Nastavte počet opakovaného oznámení (pokud je to potřeba), smazat po Y-tém selhání oznámení atd.",
        "disableReannounce": "Zakázat opakované oznámení",
        "disableReannounceDescription": "Opakované oznámení je povoleno ve výchozím nastavení. Zakázat, pokud to není potřeba",
        "reannounceInterval": "Interval opakovaného oznámení. Spustit každých X sekund",
        "reannounceIntervalPlaceholder": "7 je výchozí a doporučené",
        "deleteStalled": "Smazat pozastavené",
        "deleteStalledDescription": "Smazat pozastavené torrenty po Y pokusech",
        "reannounceMaxAttempts": "Spustit opakované oznámení Y krát"
      },
      "test": {
        "alert": "Upozornění!",
        "text": "Testovací akce nic neprovede, kromě toho, aby ukázala, zda filtr funguje. Ujistěte se, že máte otevřenou stránku Logy při testování."
      },
      "exec": {
        "title": "Spustitelné soubory",
        "subtitle": "Specifikujte spustitelný soubor a jeho argumenty, které se mají spustit při shodě filtru. Použijte absolutní cestu.",
        "path": "Cesta ke spustitelnému souboru",
        "pathPlaceholder": "Cesta ke spustitelnému souboru např. /bin/test",
        "arguments": "Argumenty",
        "argumentsPlaceholder": "Argumenty např. --test"
      },
      "watchFolder": {
        "title": "Sledované složky",
        "subtitle": "Specifikujte, kde má autobrr uložit soubory, které si stáhne. Použijte absolutní cestu.",
        "directory": "Sledovaná složka",
        "directoryPlaceholder": "Sledovaná složka např. /home/user/rwatch"
      },
      "webhook": {
        "title": "Webhooky",
        "subtitle": "Specifikujte payload, který se má odeslat do požadovaného koncového bodu při shodě filtru.",
        "endpoint": "Koncový bod",
        "endpointPlaceholder": "Host např. http://localhost/webhook",
        "endpointTooltip": "URL nebo IP vašeho API. Předejte parametry a nastavte API tokeny atd.",
        "payload": "Payload (JSON)",
        "payloadPlaceholder": "Požadovaná data: { \"klíč\": \"hodnota\" }"
      },
      "arr": {
        "overrideClientName": "Přepsat název downloadovacího klienta pro arr",
        "overrideClientNameTooltip": "Přepsat název downloadovacího klienta z toho, který je nastaven v klientech. Užitečné, pokud máte více klientů uvnitř arr.",
        "overrideClientId": "Přepsat ID downloadovacího klienta pro arr ZASTARALÉ",
        "overrideClientIdTooltip": "Přepsat ID downloadovacího klienta z toho, který je nastaven v klientech. Užitečné, pokud máte více klientů uvnitř arr."
      },
      "qbittorrent": {
        "macrosTooltip": "Toto pole může používat makra k transformaci/přidání hodnot z metadat:",
        "tags": "Tagy",
        "tagsPlaceholder": "např. tag1,tag2",
        "savePathPlaceholder": "např. /full/path/to/save_folder",
        "savePathTooltip": "Nastavte pro tuto akci vlastní cestu k uložení. Správa automatických torrentů se o to postará, pokud používáte qBittorrent s kategoriemi.",
        "downloadPath": "Cesta k downloadu",
        "downloadPathPlaceholder": "např. /full/path/to/download_folder",
        "downloadPathTooltip": "Nastavte pro tuto akci vlastní cestu k nekompletnímu stahovaní. Správa automatických torrentů se o to postará, pokud používáte qBittorrent s kategoriemi.",
        "rulesTitle": "Pravidla",
        "rulesSubtitle": "Nastavte pravidla pro vašeho torrent klienta",
        "ignoreRules": "Ignorovat existující pravidla klienta",
        "ignoreRulesDescription": "Vyberte, aby se ignorovala pravidla nastavená v Nastavení klienta.",
        "contentLayout": "Rozvržení obsahu",
        "contentLayoutDefault": "Vybrat rozvržení obsahu",
        "priority": "Priorita",
        "priorityDefault": "Vypnuto",
        "priorityTooltip": "Torrentová fronta bude pro vás povolena, pokud je vypnutá. Ujistěte se, že jste pro to nastavili své předvolby ve vašem klientovi.",
        "firstLastPiece": "Stáhnout nejdříve první a poslední části",
        "firstLastPieceDescription": "Přidat torrent a nejprve stáhnout první a poslední části torrentu"
      },
      "deluge": {
        "label": "Štítky",
        "labelPlaceholder": "např. label1 (pro fungování musí již existovat v Deluge)",
        "skipHashCheckTooltip": "Toto bude fungovat pouze na Deluge v2."
      },
      "transmission": {
        "label": "Torrent štítky",
        "labelPlaceholder": "např. label1,label2"
      },
      "rtorrent": {
        "label": "Štítky",
        "labelPlaceholder": "např. label1,label2",
        "renameToPath": "Nepřidávat název torrentu do cesty",
        "renameDefault": "Ne"
      },
      "porla": {
        "preset": "Předvolba",
        "presetPlaceholder": "např. default",
        "presetTooltip": "Název předvolby jako je nastavený v Porla, ignoruje velikost písmen.",
        "savePathPlaceholder": "např. /full/path/to/torrent/data"
      }
    },
    "addForm": {
      "title": "Vytvořit filtr",
      "subtitle": "Přidat nový filtr.",
      "closePanel": "Zavřít panel",
      "name": "Název",
      "required": "Povinné",
      "cancel": "Zrušit",
      "create": "Vytvořit",
      "added": "Filtr {{name}} byl přidán"
    }
  }
